import { namespace } from 'vuex-class';
import { ICreateDirectoryState } from './create-directory.types';

export const CreateDirectory = namespace('contentLibrary/directories/createDirectory');

export enum ECreateDirectoryAction {
  Create = 'create',
  CreateSuccess = 'createSuccess',
  CreateFailed = 'createFailed',
  UpdateDirectoryPath = 'updateDirectoryPath',
  UpdateDirectoryNames = 'updateDirectoryNames',
  Reset = 'reset',
}

export enum ECreateDirectoryMutation {
  SetCreating = 'setCreating',
  SetCreatedDirectory = 'setCreatedDirectory',
  SetDirectoryPath = 'setDirectoryPath',
  SetDirectoryNames = 'setDirectoryNames',
  SetState = 'setState',
}

export const state: ICreateDirectoryState = {
  directoryPath: '/',
  existingDirectoryNames: [],
  creating: false,
  createdDirectory: null,
};
